// extracted by mini-css-extract-plugin
module.exports = {"swiper-container":"ServiceSection_swiper-container__F5i4X","bleed-right":"ServiceSection_bleed-right__LLHat"};